import { produce } from 'immer';
import type { OutputColumns, MappedOutputColumn } from 'app/lib/types/server';
import type { TypedReduxActionOutcomes } from 'app/store/storeTypes';
import type { ExtractedError } from 'app/lib/error/types';
import { extractError } from 'app/lib/error';
import {
    GET_OUTPUT_COLUMNS_ACTION_TYPE,
    SET_OUTPUT_COLUMNS_ACTION_TYPE,
    SET_LOCAL_MAPPING,
    CLOSE
} from './types';

type ColumnsListEntry = {
    isLoading: boolean;
    error: ExtractedError | null;
    data: OutputColumns | null;
};

export type ColumnManagementSlice = {
    columns: ColumnsListEntry;
    isSettingOutputColumns: boolean;
    localMapping: Array<MappedOutputColumn>;
};
export const INITIAL_STATE: ColumnManagementSlice = {
    columns: {
        isLoading: false,
        error: null,
        data: null
    },
    isSettingOutputColumns: false,
    localMapping: []
};

export const columnManagementReducer = produce((draft, action: TypedReduxActionOutcomes) => {
    switch (action.type) {
        case GET_OUTPUT_COLUMNS_ACTION_TYPE.STARTED:
            draft.columns.isLoading = true;
            draft.columns.error = null;
            draft.columns.data = null;
            break;
        case GET_OUTPUT_COLUMNS_ACTION_TYPE.SUCCEEDED:
            draft.columns.data = action.payload;
            draft.localMapping = action.payload.mappings;
            break;
        case GET_OUTPUT_COLUMNS_ACTION_TYPE.REJECTED:
        case GET_OUTPUT_COLUMNS_ACTION_TYPE.FAILED:
            draft.columns.error = extractError(action.payload);
            break;
        case GET_OUTPUT_COLUMNS_ACTION_TYPE.ENDED:
            draft.columns.isLoading = false;
            break;

        case SET_OUTPUT_COLUMNS_ACTION_TYPE.STARTED:
            draft.isSettingOutputColumns = true;
            draft.columns.error = null;
            break;
        case SET_OUTPUT_COLUMNS_ACTION_TYPE.REJECTED:
        case SET_OUTPUT_COLUMNS_ACTION_TYPE.FAILED:
            draft.columns.error = extractError(action.payload);
            break;
        case SET_OUTPUT_COLUMNS_ACTION_TYPE.ENDED:
            draft.isSettingOutputColumns = false;
            break;
        case SET_LOCAL_MAPPING:
            draft.localMapping = action.payload;
            break;
        case CLOSE:
            draft.localMapping = draft.columns.data?.mappings ?? [];
            break;
        default:
            break;
    }
}, INITIAL_STATE);
